// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plans {
  min-width: 90%;
  min-height: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 80%;
  align-items: center;
  
}

.plans-choose {
  margin: 43px 10px 20px -40px;
}

.items {
  width: auto;
  min-width: 0;
  display: flex;
  margin: 10px 20px 10px 10px;
}

.contact {
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
  width: 400px;
  box-shadow: 24px;
  background-color: white;
  padding: 32px;
}

.contact button {
  margin-bottom: 40px;
}
.contact input {
  background-color: #ececec;
  border-radius: 10px;
}

.contact fieldset {
  border-radius: 10px;
}

.my-select {
  border-right: none;
  background-color: #ececec;
  border-radius: 10px !important;
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
  width: 70px;
  margin-top: 8px;
}

.my-select fieldset {
  border-radius: 10px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.phone {
  width: 260px;
}

.phone input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
  width: 260px;
}

.phone fieldset {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.message {
  background-color: #ececec;
  border-radius: 10px;
}

.message fieldset {
  border-radius: 10px;
}

.successModal {
  display: flex;
  width: 540px;
  height: 450px;
}

.successModal img {
  height: 446px;
}

.successModal div {
  margin: 8px;
  padding: 10px;
  border: 2px solid #CBD5E1;
  border: 2px solid var(--fx-surface-borderstrong, #CBD5E1);
}

.successModal div div {
  border: none;
  width: 235px;
  margin: 45% auto;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  font-weight: 500;
}

.popular {
  transform: scale(1.03);
  margin: 30px 20px;
  margin-right: 40px;
}

.badge {
  position: absolute;
  top: -20px;
  right: -35px;
  padding: 1px 10px;
  width: 90px;
  background-color: #9e00ff;
  color: white;
  font-weight: bold;
  transform: rotate(90deg) translateX(50%);
  -webkit-clip-path: polygon(100% 0, 0 0, 0 100%, 80% 100%);
          clip-path: polygon(100% 0, 0 0, 0 100%, 80% 100%);
}

.summary {
  min-width: 350px;
  width: auto;
  max-width: 100%;
}

.location-results {
  position: fixed;
  z-index: 2;
  width: 350px;
}

@media screen and (max-width: 1100px) {
  .checkout {
    width: 50%;
  }
}

@media screen and (max-width: 1050px) {
  .popular {
    margin-right: 20px;
  }
}

@media screen and (max-width: 900px) {
  .successModal {
    width: 450px;
    height: 400px;
  }
  .successModal img {
    height: 396px;
  }
  .popular {
    margin-left: 15px;
  }
  .contact button {
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 600px) {
  .contact {
    width: 350px;
    padding: 32px;
  }
  .phone {
    width: 210px;
  }

  .phone input {
    width: 220px;
  }
  .successModal {
    width: 450px;
    height: 350px;
  }
  .successModal img {
    height: 350px;
  }
  .successModal div div {
    width: 205px;
    margin: 30% auto;
    padding: 15px;
  }
  .checkout {
    margin-top: 30px;
  }

  .checkout h4 {
    font-size: 2.5cap;
  }

  .location-results {
    width: 300px;
  }
}

@media screen and (max-width: 400px) {
  .successModal {
    width: 340px;
    height: 300px;
  }
  .successModal img {
    height: 296px;
  }
  .successModal div div {
    width: 120;
    margin: 25% auto;
    padding: 15px;
    font-size: 15px;
  }

  .successModal div div h5 {
    font-size: 15px;
  }
  .successModal div div p {
    font-size: 12px;
    margin-bottom: 20px;
  }

  .successModal div div button {
    font-size: 10px;
    height: 25px;
  }
}

/* Plan purchase */
.checkout {
  display: flex;
  flex-wrap: wrap;
}

.column {
  box-sizing: border-box;
  padding: 20px;
}

.xs-11 {
  width: calc(50%);
}

@media screen and (max-width: 900px) {
  .sm-6 {
    width: calc(45%);
  }

  .md-6 {
    width: calc(55%);
  }

  .planLayout {
    margin-left: 80px;
  }
}

@media screen and (max-width: 700px) {
  .sm-6 {
    width: calc(100%);
  }

  .md-6 {
    width: calc(100%);
  }

  .column {
    transition: none !important;
    transform: none !important;
  }

  .column h4 h5 {
    font-size: 2.5cap;
  }

  .column {
    text-align: center;
  }

  .planLayout {
    margin-left: 0px;
  }
}

@media screen and (max-width: 1000px) {
  .successModal .sm-6 {
    width: calc(100%);
  }

  .successModal .md-6 {
    width: calc(100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/plans.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,UAAU;EACV,mBAAmB;;AAErB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,wCAAwC;EACxC,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;EACxC,yDAAiD;UAAjD,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".plans {\n  min-width: 90%;\n  min-height: 90%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  width: 80%;\n  align-items: center;\n  \n}\n\n.plans-choose {\n  margin: 43px 10px 20px -40px;\n}\n\n.items {\n  width: auto;\n  min-width: 0;\n  display: flex;\n  margin: 10px 20px 10px 10px;\n}\n\n.contact {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  text-align: center;\n  transform: translate(-50%, -50%);\n  width: 400px;\n  box-shadow: 24px;\n  background-color: white;\n  padding: 32px;\n}\n\n.contact button {\n  margin-bottom: 40px;\n}\n.contact input {\n  background-color: #ececec;\n  border-radius: 10px;\n}\n\n.contact fieldset {\n  border-radius: 10px;\n}\n\n.my-select {\n  border-right: none;\n  background-color: #ececec;\n  border-radius: 10px !important;\n  border-bottom-right-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n  width: 70px;\n  margin-top: 8px;\n}\n\n.my-select fieldset {\n  border-radius: 10px;\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.phone {\n  width: 260px;\n}\n\n.phone input {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: none;\n  width: 260px;\n}\n\n.phone fieldset {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.message {\n  background-color: #ececec;\n  border-radius: 10px;\n}\n\n.message fieldset {\n  border-radius: 10px;\n}\n\n.successModal {\n  display: flex;\n  width: 540px;\n  height: 450px;\n}\n\n.successModal img {\n  height: 446px;\n}\n\n.successModal div {\n  margin: 8px;\n  padding: 10px;\n  border: 2px solid var(--fx-surface-borderstrong, #CBD5E1);\n}\n\n.successModal div div {\n  border: none;\n  width: 235px;\n  margin: 45% auto;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  box-sizing: border-box;\n  text-align: center;\n  font-weight: 500;\n}\n\n.popular {\n  transform: scale(1.03);\n  margin: 30px 20px;\n  margin-right: 40px;\n}\n\n.badge {\n  position: absolute;\n  top: -20px;\n  right: -35px;\n  padding: 1px 10px;\n  width: 90px;\n  background-color: #9e00ff;\n  color: white;\n  font-weight: bold;\n  transform: rotate(90deg) translateX(50%);\n  clip-path: polygon(100% 0, 0 0, 0 100%, 80% 100%);\n}\n\n.summary {\n  min-width: 350px;\n  width: auto;\n  max-width: 100%;\n}\n\n.location-results {\n  position: fixed;\n  z-index: 2;\n  width: 350px;\n}\n\n@media screen and (max-width: 1100px) {\n  .checkout {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 1050px) {\n  .popular {\n    margin-right: 20px;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .successModal {\n    width: 450px;\n    height: 400px;\n  }\n  .successModal img {\n    height: 396px;\n  }\n  .popular {\n    margin-left: 15px;\n  }\n  .contact button {\n    margin-bottom: 10px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .contact {\n    width: 350px;\n    padding: 32px;\n  }\n  .phone {\n    width: 210px;\n  }\n\n  .phone input {\n    width: 220px;\n  }\n  .successModal {\n    width: 450px;\n    height: 350px;\n  }\n  .successModal img {\n    height: 350px;\n  }\n  .successModal div div {\n    width: 205px;\n    margin: 30% auto;\n    padding: 15px;\n  }\n  .checkout {\n    margin-top: 30px;\n  }\n\n  .checkout h4 {\n    font-size: 2.5cap;\n  }\n\n  .location-results {\n    width: 300px;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .successModal {\n    width: 340px;\n    height: 300px;\n  }\n  .successModal img {\n    height: 296px;\n  }\n  .successModal div div {\n    width: 120;\n    margin: 25% auto;\n    padding: 15px;\n    font-size: 15px;\n  }\n\n  .successModal div div h5 {\n    font-size: 15px;\n  }\n  .successModal div div p {\n    font-size: 12px;\n    margin-bottom: 20px;\n  }\n\n  .successModal div div button {\n    font-size: 10px;\n    height: 25px;\n  }\n}\n\n/* Plan purchase */\n.checkout {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.column {\n  box-sizing: border-box;\n  padding: 20px;\n}\n\n.xs-11 {\n  width: calc(50%);\n}\n\n@media screen and (max-width: 900px) {\n  .sm-6 {\n    width: calc(45%);\n  }\n\n  .md-6 {\n    width: calc(55%);\n  }\n\n  .planLayout {\n    margin-left: 80px;\n  }\n}\n\n@media screen and (max-width: 700px) {\n  .sm-6 {\n    width: calc(100%);\n  }\n\n  .md-6 {\n    width: calc(100%);\n  }\n\n  .column {\n    transition: none !important;\n    transform: none !important;\n  }\n\n  .column h4 h5 {\n    font-size: 2.5cap;\n  }\n\n  .column {\n    text-align: center;\n  }\n\n  .planLayout {\n    margin-left: 0px;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .successModal .sm-6 {\n    width: calc(100%);\n  }\n\n  .successModal .md-6 {\n    width: calc(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
